import { MAX_IDLE_TIME } from "../constants";

export type SetInactiveCallback = (inactive: boolean) => void;

class InactivityService {
  private inactivityTime: number;
  private setInactiveCallback: SetInactiveCallback;
  private timeoutId: NodeJS.Timeout | undefined;
  private userActive: boolean;

  constructor(callback: SetInactiveCallback) {
    this.inactivityTime = MAX_IDLE_TIME;
    this.setInactiveCallback = callback;
    this.timeoutId = undefined;
    this.userActive = true;
  }

  public start() {
    this.timeoutId = this.createTimeout();
    this.addListeners(this.renewTimeout); // create inactivity listeners
  }

  public stop() {
    clearTimeout(this.timeoutId);
    this.removeListeners(this.renewTimeout);
    this.removeListeners(this.makeUserActive);
  }

  private createTimeout() {
    return setTimeout(this.makeUserInactive, this.inactivityTime);
  }

  private makeUserInactive = () => {
    this.userActive = false;
    this.setInactiveCallback(true);
    this.removeListeners(this.renewTimeout); // stop inactivity listeners
    this.addListeners(this.makeUserActive); // create activity listeners
  };

  private makeUserActive = () => {
    this.userActive = true;
    this.setInactiveCallback(false);
    this.removeListeners(this.makeUserActive); // stop activity listeners
    this.start(); // make a new timeout and create inactivity listeners
  };

  private renewTimeout = () => {
    clearTimeout(this.timeoutId);
    // check just to be safe before we start the timeout again
    if (this.userActive) this.timeoutId = this.createTimeout();
  };

  private addListeners(callback: () => void) {
    window.addEventListener("mousemove", callback);
    window.addEventListener("keydown", callback);
    window.addEventListener("scroll", callback);
    window.addEventListener("click", callback);
  }

  private removeListeners(callback: () => void) {
    window.removeEventListener("mousemove", callback);
    window.removeEventListener("keydown", callback);
    window.removeEventListener("scroll", callback);
    window.removeEventListener("click", callback);
  }
}

export default InactivityService;
